// removed by extract-text-webpack-plugin
module.exports = {"component":"sjkNrjJrCOYPFub43ea-E","header":"YSq9vrON8FopaHiZPpVRO","instructions":"_1AMh5jjQSa4V3q07WD49Ss","formWrapper":"_11E50QXRfHdRQtXHHHjfDg","hidden":"_3wmBdemnn1TOBmIlnjXH73","group":"_1nJBHXWHkgvgBf6RJkKgWI","control":"s5KOjHS5vGLF2FwRT8N-w","unlockIcon":"Kxbf-YGDqCPHvXALa4Y8Z","lockIcon":"_1Zuvj3qX7WrF_ibYYOIFN","textarea":"_2Sr3Ru9teA3wb19FTd7n8E","btn":"_2wrCS_30JjrC7gk3aMjOR7","btnSecondary":"_1TsZl7y0Bpa-2qrL9UBue3","btnPrimary":"_2-ql_ARG_nPcOoyU6sAalT","actions":"_2RIylE_SiMNaUpUZiJaHMd","margins":"_3OF0td8DYBISzFO9iPvM6i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordTransmitForm/HealthRecordTransmitForm.css
// module id = 1270
// module chunks = 0